const CODE_FORMAT = 'YYYY-MM-DD';

export const VIEW_FORMAT = 'DD/MM/YYYY';

export const WEEKS_MONTH = ['1', '2', '3', '4', '5'];

export const WEEK_MONTH_DESCRIPTIONS = {
  1: 'Sem. 1',
  2: 'Sem. 2',
  3: 'Sem. 3',
  4: 'Sem. 4',
  5: 'Sem. 5',
};

export function formatToCode(date) {
  return date.format(CODE_FORMAT);
}
